import { render } from "./AppSidebarNavs.vue?vue&type=template&id=4625fe26"
import script from "./AppSidebarNavs.vue?vue&type=script&lang=js"
export * from "./AppSidebarNavs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__